var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.926453,
    y: 0.536255,
    width: 45.0735,
    height: 45.0735,
    rx: 22.5368,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4633 13.6399C28.6353 13.6399 32.8536 17.8582 32.8536 23.0303C32.8536 28.239 28.6353 32.4206 23.4633 32.4206C18.2546 32.4206 14.0729 28.239 14.0729 23.0303C14.0729 17.8582 18.2546 13.6399 23.4633 13.6399ZM23.4633 18.3351C22.803 18.3351 22.2895 18.8853 22.2895 19.5089C22.2895 20.1691 22.803 20.6827 23.4633 20.6827C24.0868 20.6827 24.637 20.1691 24.637 19.5089C24.637 18.8853 24.0868 18.3351 23.4633 18.3351ZM24.9305 27.7254C25.4073 27.7254 25.8108 27.3586 25.8108 26.8451C25.8108 26.3682 25.4073 25.9647 24.9305 25.9647H24.3436V22.7368C24.3436 22.26 23.9401 21.8565 23.4633 21.8565H22.2895C21.7759 21.8565 21.4091 22.26 21.4091 22.7368C21.4091 23.2503 21.7759 23.6172 22.2895 23.6172H22.5829V25.9647H21.996C21.4825 25.9647 21.1157 26.3682 21.1157 26.8451C21.1157 27.3586 21.4825 27.7254 21.996 27.7254H24.9305Z",
    fill: "url(#paint0_linear_1064_8152)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1064_8152",
    x1: 20.1659,
    y1: 31.073,
    x2: 30.7854,
    y2: 18.4624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A0F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fafb338cbd5f7b33150c8550faaea6e1.svg";
export { ForwardRef as ReactComponent };